module.exports = __webpack_public_path__ + "static/media/icon-traslados.a722a020.svg";